import {
  LOCATIONSFORPOSTINGS_GET_REQUEST,
  LOCATIONSFORPOSTINGS_GET_SUCCESS,
  LOCATIONSFORPOSTINGS_GET_FAILURE,
  LOGIN_SUCCESS,
} from '../../../actions/constants/types';

const initialState = {
  isFetching: false,
  serverDateTime: '',
  items: [],
};

function locationsForPostings(state = initialState, action) {
  switch (action.type) {
    case LOCATIONSFORPOSTINGS_GET_REQUEST:
      return { ...state, isFetching: true };
    case LOCATIONSFORPOSTINGS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.response.data.postings,
        lastUpdated: action.receivedAt,
        serverDateTime: action.response.data.serverDateTime,
      };
    case LOCATIONSFORPOSTINGS_GET_FAILURE:
    case LOGIN_SUCCESS:
      return initialState;
    default:
      return state;
  }
}

export default locationsForPostings;
